import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  CashFlowReportParams,
  CashFlowReportResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CASH_FLOW_REPORT_QUERY_KEY = 'cash_flow_report';

export const useCashFlowReportQuery = (
  url: string,
  params: CashFlowReportParams,
) => {
  const { period, location } = params;

  return useQuery({
    queryKey: [CASH_FLOW_REPORT_QUERY_KEY, url, params],
    queryFn: () =>
      HttpClient.request<CashFlowReportResponse>({
        method: 'GET',
        url,
        params: {
          filters: {
            period,
            ...(location.length ? { location } : {}),
          },
        },
      }),
    enabled: !!period.from && !!period.till,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
};
